var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({class:["mpx-root-view","host-_e36148a6"]},_vm.$listeners),[_c('div',[_c('div',{class:["picker-demo-title"]},[_vm._v("Config delay step:")]),_c('cube-time-picker',{attrs:{"delay":(_vm.delay)}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }